module.exports = __webpack_public_path__ + "static/media/content-placeholder.cd33f523.png";